var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 38,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 38,
    rx: 4,
    stroke: "#DBE2E9",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4636 11.6667C16.7499 11.6667 14.5 14.1639 14.5 16.6303C14.5 17.5076 14.5053 18.6306 14.8739 19.7365C15.0194 20.1731 14.7835 20.645 14.3468 20.7906C13.9102 20.9361 13.4383 20.7001 13.2927 20.2635C12.8332 18.8848 12.8333 17.5227 12.8333 16.659L12.8333 16.6303C12.8333 13.2997 15.7742 10 19.4636 10C21.7426 10 23.7521 11.1502 24.9446 12.8985H25.2606C26.6484 12.8985 27.9943 13.3828 29.0053 14.1805C30.0152 14.9774 30.75 16.1414 30.75 17.5C30.75 17.5182 30.75 17.5364 30.75 17.5548C30.7503 18.3583 30.7506 19.3622 30.2453 20.3727C30.0395 20.7843 29.539 20.9512 29.1273 20.7454C28.7157 20.5395 28.5488 20.039 28.7546 19.6273C29.0712 18.9943 29.0833 18.3543 29.0833 17.5C29.0833 16.7753 28.6906 16.0552 27.9729 15.4889C27.2561 14.9233 26.2739 14.5652 25.2606 14.5652H24.4851C24.1876 14.5652 23.9127 14.4066 23.7637 14.1491C22.9042 12.6633 21.2998 11.6667 19.4636 11.6667ZM21.5833 17.6042C22.0436 17.6042 22.4166 17.9773 22.4166 18.4375V26.587L24.4091 24.675C24.7412 24.3564 25.2687 24.3673 25.5874 24.6993C25.906 25.0314 25.8951 25.5589 25.5631 25.8776L22.1603 29.1428C21.8379 29.4522 21.3288 29.4522 21.0063 29.1428L17.6036 25.8776C17.2715 25.5589 17.2606 25.0314 17.5792 24.6993C17.8979 24.3673 18.4254 24.3564 18.7575 24.675L20.75 26.587V18.4375C20.75 17.9773 21.1231 17.6042 21.5833 17.6042Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIc);
export default __webpack_public_path__ + "static/media/download_ic.5bb131ce4a2bdd4326956b3abde86906.svg";
export { ForwardRef as ReactComponent };